import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useAppDispatch } from "../../redux/store";
import { login } from "../../redux/features/auth/authSlice";

const VALID_USER = "admin";
const VALID_PASS = "admin";

interface LoginDialogProps {
  open: boolean;
  onClose: () => void;
}

function LoginDialog({ open, onClose }: LoginDialogProps) {
  const dispatch = useAppDispatch();
  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (user === VALID_USER && pass === VALID_PASS) {
      dispatch(login());
      setUser("");
      setPass("");
      setError("");
      onClose();
    } else {
      setError("Usuario o contraseña incorrectos");
    }
  };

  const handleClose = () => {
    setUser("");
    setPass("");
    setError("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      slotProps={{ paper: { component: "form", onSubmit: handleSubmit } }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Iniciar sesión
        <IconButton size="small" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2} mt={1}>
          <TextField
            label="Usuario"
            value={user}
            onChange={(e) => {
              setUser(e.target.value);
              setError("");
            }}
            size="small"
            fullWidth
            autoFocus
          />
          <TextField
            label="Contraseña"
            type={showPass ? "text" : "password"}
            value={pass}
            onChange={(e) => {
              setPass(e.target.value);
              setError("");
            }}
            size="small"
            fullWidth
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => setShowPass((v) => !v)}
                      edge="end"
                    >
                      {showPass ? (
                        <VisibilityOffIcon fontSize="small" />
                      ) : (
                        <VisibilityIcon fontSize="small" />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
          {error && (
            <Typography variant="body2" color="error">
              {error}
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button type="submit" variant="contained">
          Entrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default LoginDialog;
